import SettingGroupList from "./setting-group-list";

export default SettingGroupList;
